<template>
  <el-autocomplete
    v-model="value.name"
    :fetch-suggestions="querySearchAsync"
    :placeholder="placeholder"
    @input="handleInput"
    @select="handleSelect($event)"
  >
  <i slot="suffix" class="el-input__icon el-icon-arrow-down"></i>
  </el-autocomplete>
</template>

<script>
export default {
  props: {
    value: {},
    placeholder: {
      type: String,
      default: '请选择品牌（可搜索）'
    },

  },
  methods: {
    querySearchAsync(queryString, cb) {
      var restaurants = this.value.restaurants;
      cb(restaurants);
    },
    handleInput(e) {
      this.$emit("handleInput", e);
    },
    handleSelect(e) {
      this.$emit("handleSelect", e);
    },
  },
};
</script>

<style>
</style>